export const MAX_WAREHOUSES = 10
export const DEFAULT_WAREHOUSE_CODE = 'BOD-01'
export const DEFAULT_WAREHOUSE_NAME = 'Bodega principal'
